var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCaretBack = function SvgCaretBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.098 8.004 1.512 6.59l7.07 7.07-1.413 1.415L.098 8.004Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7.168.934 1.414 1.414-7.07 7.07L.096 8.006 7.168.934Z"
  })));
};
export { SvgCaretBack as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTUgMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZD0iTTAuMDk3NjU2MiA4LjAwMzkxTDEuNTExODcgNi41ODk2OUw4LjU4Mjk0IDEzLjY2MDhMNy4xNjg3MiAxNS4wNzVMMC4wOTc2NTYyIDguMDAzOTFaIiAvPgogIDxwYXRoIGQ9Ik03LjE2Nzk3IDAuOTMzNTk0TDguNTgyMTggMi4zNDc4MUwxLjUxMTExIDkuNDE4ODdMMC4wOTY5MDA1IDguMDA0NjZMNy4xNjc5NyAwLjkzMzU5NFoiIC8+Cjwvc3ZnPgo=";